import {
    IconButton,
    InputAdornment,
    InputProps,
    TextField,
    TextFieldProps,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Close'
import React from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash-es'
import { Paper, InputBase } from '@mui/material'
interface IProps {
    searchValue?: (value: string) => void
    delay?: number
    initValue?: string
    clearable?: boolean

    /** if TRUE, will always applied clear icon */
    stickyClear?: boolean

    onClear?: () => void
    inputRef?: any
    searchInputVariant?: 'outlined' | 'filled'
}
const SearchPaper = (props: InputProps) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
            }}
        >
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={props.placeholder}
                value={props.value}
                inputProps={props.inputProps}
                onChange={props.onChange}
            />
            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                <SearchIcon />
            </IconButton>
        </Paper>
    )
}

function SearchField(props: IProps & TextFieldProps) {
    const { t } = useTranslation()
    const {
        searchValue,
        delay = 400,
        initValue = '',
        clearable = false,
        stickyClear = false,
        onClear,
        placeholder = t('common.search'),
        inputRef,
        searchInputVariant = 'outlined',
        ...textFieldProps
    } = props
    const [value, setValue] = React.useState(initValue)

    const handleOnClear = () => {
        setValue('')
        onClear && onClear()
    }

    const debouncedHandleOnChange = useDebouncedCallback((newValue: string) => {
        searchValue?.(newValue)
    }, delay)

    const handleField = (e: any) => {
        const newValue = e.currentTarget.value
        setValue(newValue)

        if (delay > 0) debouncedHandleOnChange.callback(newValue)
        else searchValue?.(newValue)
    }

    React.useEffect(() => {
        setValue(initValue)
    }, [initValue])

    if (searchInputVariant === 'filled')
        return (
            <SearchPaper
                value={value}
                placeholder={placeholder}
                onChange={handleField}
            />
        )
    return (
        <TextField
            {...textFieldProps}
            fullWidth
            placeholder={placeholder}
            value={value}
            ref={inputRef}
            onChange={handleField}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (stickyClear ||
                    (clearable && !isEmpty(value))) && (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={handleOnClear}>
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        ></TextField>
    )
}

export default SearchField
